export default __webpack_public_path__ + "static/media/map_faq.96426077.png";